import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

type Props = {
  title: string;
  slug: string;
  excerpt: string;
  type: Page;
};

const Title = styled.h2`
  color: #444;
  font-size: 1.1rem;
  margin: 1rem;
  line-height: 1.3;
  min-height: calc(1.3em * 2);
`;

const MainInfo = styled(Link)`
  grid-area: mainInfo;
  text-decoration: none;
`;

const CardMainInfo: React.VFC<Props> = ({ title, slug, excerpt, type }) => (
  <MainInfo to={`/${type}s/${slug}`}>
    <Title>{title}</Title>
  </MainInfo>
);

export default CardMainInfo;
